import { cashMovementDetailSelectorConfig } from './cashMovementDetail'

export const selectorsConfig = {
  ...cashMovementDetailSelectorConfig,
}
